<template>
    <div class="lg:p-12 bg-gray-100 rounded p-4">
        <h2 class="text-3xl font-bold text-center text-themeColor mb-4">
            {{ $t('post.list.my_posts') }}
        </h2>
        <p class="text-lg text-center">
            {{ $t('post.list.my_posts_author') }}
        </p>
        <PostsTable></PostsTable>
    </div>
</template>

<script>
import PostsTable from '@/components/Model/Post/Table/PostsTable'

export default {
    name: 'Posts',
    components: {
        PostsTable
    },
    data() {
        return {}
    },
    computed: {},
    created() {},
    methods: {}
}
</script>
